import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IconComponent } from 'src/app/core/modules/icons/components/icon/icon.component';
import { IconsModule } from 'src/app/core/modules/icons/icons.module';
import { SafeHtmlPipe } from 'src/app/core/pipes/safe-html.pipe';
import { AnalyticsService } from 'src/app/core/services/analytics.service';
import { GlobalService } from 'src/app/core/services/global.service';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss',`./styles/contact.${env.template_id}.component.scss`],
  standalone:true,
  imports:[
    CommonModule,
    SafeHtmlPipe,
    IconsModule
  ]
})
export class ContactComponent {

  constructor(
    public globalService: GlobalService,
    private _analyticsService: AnalyticsService,
  ) { }

  click(source: string){
    this._analyticsService.trackEvent({ event: `${source}_button`, data: {} });
  }
}
